import { useSelector } from 'react-redux';
import { ChannelType } from 'api/ChannelsAPI';
import { selectFeatureFlags } from 'core/userContext';
import { MessageMedium } from 'constants/messageMediums';
import { useFetchFrequencyManagement } from '../../hooks/useFetchFrequencyManagement';
import {
  createIsMessageMediumFrequencyManaged,
  createIsMessageTypeFrequencyManaged,
  isMessageChannelFrequencyManagementEligible,
} from '../utils/settingsUtils';

type State = {
  isFrequencyManagementEnabled: boolean;
  isMessageMediumFrequencyManaged: (messageMedium: MessageMedium) => boolean;
  isMessageChannelFrequencyManagementEligible: (
    channelType: ChannelType,
    messageMedium: MessageMedium,
  ) => boolean;
  isMessageTypeFrequencyManaged: (messageTypeId: number, messageMedium: MessageMedium) => boolean;
};

const defaultState: State = {
  isFrequencyManagementEnabled: false,
  isMessageMediumFrequencyManaged: () => false,
  isMessageChannelFrequencyManagementEligible: () => false,
  isMessageTypeFrequencyManaged: () => false,
};

export const useFrequencyManagementSettings = ({ skip = false }: { skip?: boolean }): State => {
  const { FrequencyCappingV2, FrequencyCappingMessageType } = useSelector(selectFeatureFlags);
  const isFrequencyManagementEnabled = FrequencyCappingV2 || FrequencyCappingMessageType;

  const { data, error, isLoading } = useFetchFrequencyManagement({
    skip: skip || !isFrequencyManagementEnabled,
  });

  if (!isFrequencyManagementEnabled || !data || isLoading || error) {
    return defaultState;
  }

  const isMessageMediumFrequencyManaged = createIsMessageMediumFrequencyManaged(data);

  const isMessageTypeFrequencyManaged = createIsMessageTypeFrequencyManaged(data);

  return {
    isFrequencyManagementEnabled,
    isMessageChannelFrequencyManagementEligible,
    isMessageMediumFrequencyManaged,
    isMessageTypeFrequencyManaged,
  };
};
